import styled from 'styled-components/macro';
import chevron from 'assets/icons/chevron.svg';

export const Wrapper = styled.div<{ isDisabled?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex-grow: 1;
  opacity: ${(props) => (props.isDisabled ? 0.5 : 1)};
  box-sizing: border-box;

  & > img,
  input {
    pointer-events: ${(props) => (props.isDisabled ? 'none' : '')};
    cursor: ${(props) => (props.isDisabled ? 'default' : '')};
  }

  & > div > div > div > img {
    cursor: ${(props) => (props.isDisabled ? 'default' : '')};
  }

  ${(props) =>
    props.isDisabled &&
    `
    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgb(125 163 201 / 10%);
      z-index: 1;
      border-radius: 8px;
    }
  `}
`;

export const SearchWrapper = styled.div<{
  isActive: boolean;
  isDisabled?: boolean;
  invalid?: boolean;
}>`
  box-sizing: border-box;
  display: flex;
  max-height: 40px;
  border-radius: 8px;
  border-width: 1px;
  border-style: solid;
  border-color: ${(props) =>
    props.invalid ? '#feb2b2' : props.isActive ? '#2d67d8' : '#ced5de'};

  box-shadow: ${(props) =>
    props.isActive ? '0px 0px 0px 4px #e0eeff' : 'none'};

  :hover {
    border-color: ${(props) =>
      props.invalid
        ? '#feb2b2'
        : props.isActive
          ? '#2d67d8'
          : props.isDisabled
            ? '#ced5de'
            : '#9da6b4'};
  }
`;

export const TypeSelect = styled.div<{ isFixed?: boolean }>`
  min-width: ${(props) => (props.isFixed ? '67px' : '91px')};
`;

export const SelectWrapper = styled.div`
  width: 100%;
  position: relative;
`;

export const SelectInnerWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  color: #1f2939;
  height: 38px;
  box-shadow: none;
  border-radius: 0 8px 8px 0;
  border: none;
  border-left: 1px solid #ced5de;
`;

export const SelectTextWrapper = styled.div`
  padding: 12px 0 12px 12px;
  width: 67px;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  color: #1f2939;
  box-sizing: border-box;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  margin: 0;
  cursor: default;
`;

export const SearchInput = styled.input`
  outline: none;
  border: none;
  width: calc(100% - 56px);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  color: #1f2939;
  padding: 8px 16px 8px 8px;

  ::placeholder {
    color: #98a3b4;
    line-height: 20px;
  }
`;

export const WrapperInTypeSelect = styled.div`
  display: flex;
  align-items: center;
  background-color: #f8f9fa;
  height: 37px;
  box-shadow: none;
  border-radius: 8px 0 0 8px;
  border: none;
`;

export const ChevronIcon = styled.img.attrs({
  src: chevron,
})`
  box-sizing: content-box !important;
  padding: 8px 8px 8px 0;
  rotate: 0;
  height: 16px;
  width: 16px;
  cursor: pointer;
`;
